/**
 * 안내문 마크다운 이미지 출처 화이트리스트 — 안내문 이미지 업로드(POST /auth/notice-image)가
 * 돌려주는 서버 경로와 https 만 허용한다. `javascript:`·`data:`·프로토콜 상대(`//`)·임의 상대경로는
 * 전부 거부되어 설명(alt) 평문으로만 남는다(링크의 SAFE_URL 과 같은 원칙).
 * JSX 없는 .ts 로 둔 이유: 렌더러(markdown.tsx)는 jest 범위 밖이라 이 규칙만 따로 검증한다.
 */
export const SAFE_IMAGE_URL = /^(https:\/\/[^\s"'<>]+|\/public-upload\/notice-image\/MoPeer-[0-9a-f]{64}\/[A-Za-z0-9._-]+)$/;

export function isSafeImageUrl(url: string): boolean {
  return SAFE_IMAGE_URL.test(url);
}
